import React from "react";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Color from "../../../utils/Color";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  containerStyle:{
    borderRadius: 5,
    backgroundColor: "white",
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 20,
    paddingRight: 20
  },
  titleTextStyle:{
    color: "#2c3034"
  }
}));
const RowSection = ({title, icon, onClickRowSection}) => {
  const classes = useStyles();

  return(
    <div className={classes.containerStyle} onClick={onClickRowSection}>
      <Grid container direction={"row"} justify={"space-between"} alignItems={"center"}>
          <Grid item xs={11}>
            <CustomText design={classes.titleTextStyle}>{title}</CustomText>
          </Grid>
        <Grid item xs={1}>
          <Grid container direction={"row"} justify={"flex-end"}>
            <Grid item>
              {icon}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
};

export default RowSection;
